import session from '@/utils/session'
export default {
  state: {
    parkList: [{
      name: '',
      id: 1
    }],
    parkId: 1
  },
  getters: {
    parkList: state => {
      return state.parkList
    },
    parkId: state => {
      return window.parent.parkId || state.parkId
    },
    parkName: state => {
      const parkInfo = state.parkList.find(area => {
        return state.parkId === area.id
      })
      const parkName = parkInfo ? parkInfo.name : state.parkList[0].name
      return parkName
    }
  },
  mutations: {
    setParkList: (state, data) => {
      state.parkList = data
    },
    setParkId: (state, data) => {
      state.parkId = data
      window.parkId = data
      session.set('parkId', data)
    }
  },
  actions: {
    setParkList: ({commit}, value) => {
      commit('setParkList', value)
    },
    setParkId: ({commit}, value) => {
      commit('setParkId', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/area-base/store/areaSelect.js